import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { VisibleScenarios } from '../../types';

interface WealthChartProps {
  data: any[];
  visibleScenarios: VisibleScenarios;
  formatCurrency: (value: number, compact?: boolean) => string;
}

export const WealthChart: React.FC<WealthChartProps> = ({
  data,
  visibleScenarios,
  formatCurrency
}) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
        <XAxis dataKey="year" tick={{ fontSize: 11, fill: '#6b7280' }} stroke="#d1d5db" />
        <YAxis tickFormatter={(value) => formatCurrency(value, true)} tick={{ fontSize: 11, fill: '#6b7280' }} stroke="#d1d5db" />
        <Tooltip
          formatter={(value: number) => [formatCurrency(value), '']}
          contentStyle={{ border: '1px solid #d1d5db', borderRadius: 0, fontSize: 12 }}
        />
        <Legend
          wrapperStyle={{ fontSize: 12, paddingTop: 16 }}
          formatter={(value) => <span style={{ color: '#374151' }}>{value}</span>}
        />
        {visibleScenarios.rent && <Line type="monotone" dataKey="rentTotal" stroke="#111827" strokeWidth={3} name="Keep & Rent (property + invested income)" dot={false} />}
        {visibleScenarios.sell100 && <Line type="monotone" dataKey="sell100" stroke="#6b7280" strokeWidth={2} name="Sell & Invest (100% stocks)" dot={false} />}
        {visibleScenarios.sell80_20 && <Line type="monotone" dataKey="sell80_20" stroke="#9ca3af" strokeWidth={2} name="Sell & Invest (80/20 portfolio)" dot={false} />}
        {visibleScenarios.sell60_40 && <Line type="monotone" dataKey="sell60_40" stroke="#d1d5db" strokeWidth={2} name="Sell & Invest (60/40 portfolio)" dot={false} />}
      </LineChart>
    </ResponsiveContainer>
  );
};
